'use client';

import { c as _c } from "react/compiler-runtime";
import React, { PropsWithChildren, FC, useCallback, useMemo } from 'react';
import { useRouter } from 'next/navigation';
import { AppState, Auth0Provider as Auth0, CacheLocation } from '@auth0/auth0-react';
import { useEnvironmentContext } from '@/providers/environment.provider';
export const Auth0Provider: FC<PropsWithChildren> = t0 => {
  const $ = _c(13);
  const {
    children
  } = t0;
  const router = useRouter();
  const env = useEnvironmentContext();
  let t1;
  if ($[0] !== router) {
    t1 = appState => {
      const url = appState && appState.returnTo ? appState.returnTo : window.location.origin;
      router.push(url);
    };
    $[0] = router;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onRedirectCallback = t1;
  const t2 = env.auth0domain || "";
  const t3 = env.auth0clientId || "";
  const t4 = env.auth0scope || "read:current_user update:current_user_metadata";
  let t5;
  if ($[2] !== env.auth0audience || $[3] !== t4) {
    t5 = {
      redirect_uri: typeof window !== "undefined" ? window.location.origin : "/",
      scope: t4,
      audience: env.auth0audience
    };
    $[2] = env.auth0audience;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== onRedirectCallback || $[6] !== t2 || $[7] !== t3 || $[8] !== t5) {
    t6 = {
      domain: t2,
      clientId: t3,
      cacheLocation: "localstorage" as CacheLocation,
      useRefreshTokens: true,
      onRedirectCallback,
      authorizationParams: t5
    };
    $[5] = onRedirectCallback;
    $[6] = t2;
    $[7] = t3;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  const providerConfig = t6;
  let t7;
  if ($[10] !== children || $[11] !== providerConfig) {
    t7 = <Auth0 {...providerConfig}>{children}</Auth0>;
    $[10] = children;
    $[11] = providerConfig;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  return t7;
};